import React from 'react';
import { pushGtmEvent } from 'analytics/gtm';
import { FiChevronRight } from 'react-icons/fi';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

import { Card } from 'design-system';
import { ReactComponent as FuelRequestIcon } from 'design-system/assets/fuel-request.svg';
import { ReactComponent as BillsIcon } from 'design-system/assets/bills.svg';
import { ReactComponent as NotesIcon } from 'design-system/assets/notes.svg';
import { ReactComponent as MaintenanceIcon } from 'design-system/assets/maintenance.svg';
import { ReactComponent as CustomerServiceIcon } from 'design-system/assets/customer-service.svg';
import { ReactComponent as ChatIcon } from 'design-system/assets/chat.svg';

import { QuickActionsGrid } from './styles';

const baseCards = [
  {
    icon: FuelRequestIcon,
    title: 'Solicitação de abastecimento',
    to: '/pedido-abastecimento',
  },
  {
    icon: MaintenanceIcon,
    title: 'Solicitação de manutenção',
    to: '/manutencao',
  },
  {
    icon: NotesIcon,
    title: '2ª via de notas fiscais',
    to: '/notas',
  },
  {
    icon: BillsIcon,
    title: '2ª via de boletos',
    to: '/boletos',
  },
  {
    icon: CustomerServiceIcon,
    title: 'Atendimento comercial',
    to: '/atendimento-comercial',
  },
];

const mobileOnlyCard = {
  icon: ChatIcon,
  title: 'Fale conosco',
  to: '/fale-conosco',
};

const CTOS = (): JSX.Element => {
  const history = useHistory();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const cards = isMobile ? [...baseCards, mobileOnlyCard] : baseCards;

  return (
    <QuickActionsGrid className="cards-intro">
      {cards.map((card) => {
        const Icon = card.icon;

        return (
          <Card
            key={card.to}
            size={isMobile ? 'sm' : 'md'}
            title={card.title}
            icon={<Icon />}
            trailing={<FiChevronRight />}
            borderColor="#ebebeb"
            onClick={() => {
              pushGtmEvent({
                event: 'click_cta',
                eventCategory: 'home',
                eventAction: 'click',
                eventLabel: card.title,
                pageSection: 'home',
                elementType: 'button',
              });
              history.push(card.to);
            }}
          />
        );
      })}
    </QuickActionsGrid>
  );
};

export default CTOS;
